/**
 * Validates a return URL to prevent open redirect attacks.
 * Only allows relative paths or same-origin URLs.
 * Rejects external URLs, javascript: protocols, etc.
 * 
 * @param returnUrl - The URL to validate
 * @returns true if the URL is safe to redirect to, false otherwise
 */
export const isValidReturnUrl = (returnUrl: string): boolean => {
  if (!returnUrl || typeof returnUrl !== 'string') {
    return false;
  }

  // Trim whitespace
  const url = returnUrl.trim();
  
  // Reject empty strings
  if (!url) {
    return false;
  }

  // Reject URLs that start with protocols (http, https, javascript, data, etc.)
  if (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(url)) {
    return false;
  }

  // Reject URLs that start with // (protocol-relative URLs)
  if (url.startsWith('//')) {
    return false;
  }

  // Only allow relative paths that start with /
  if (!url.startsWith('/')) {
    return false;
  }

  // Reject paths that try to navigate to parent directories excessively
  // This prevents paths like /../../../etc/passwd
  if (url.includes('/../') || url.endsWith('/..')) {
    return false;
  }

  // Additional safety: reject URLs with suspicious characters
  if (/[<>'"\\]/.test(url)) {
    return false;
  }

  return true;
};
